import { createBrowserHistory } from 'history';

// Browser history singleton
export const history = createBrowserHistory();